import { useEffect, useState } from "react";
import { Outlet, useParams } from "react-router-dom";

import Header from "../header/Header";
import LoadingSvg from "../loadingSvg/LoadingSvg";
import Toolbar from "../Toolbar";

import { Auth, readToken, retrieveToken, retrieveTokenDev } from "../../utils/auth/Auth";
import { ContextProvider } from "../contextProvider/ContextProvider";

/**
 * A wrapper component that checks for user authentication
 * and only renders child routes if a token is present.
 * It also handles development-specific token retrieval.
 * @return {JSX.Element}
 */
const PrivateRoute = () => {
    const { userName } = useParams();

    const [token, setToken] = useState(null);
    const [isLoading, setIsLoading] = useState(true); // 👈 NEW STATE

    /**
     * username is strictly a development var
     */
    useEffect(() => {
        const fetchToken = async () => {
            const existingToken = readToken();
            if (existingToken && (existingToken.expiry || 0) > Date.now()) {
                setToken(existingToken);
                setIsLoading(false);
                return;
            }

            let response;
            if (userName && process.env.NODE_ENV !== "production") {
                // Dev path with specific userName
                response = await retrieveTokenDev(0, userName);
            } else if (process.env.NODE_ENV !== "production" && sessionStorage.getItem("devLogin") === "devLogin") {
                // Dev path with default user
                response = await retrieveTokenDev(0, null);
            } else {
                // Production path
                response = await retrieveToken();
            }

            setToken(response);
            setIsLoading(false);
        };

        fetchToken();
    }, [userName]);

    if (isLoading) {
        return <LoadingSvg />;
    }

    // If authorized, return an outlet that will render child elements
    if (token) {
        return (
            <ContextProvider>
                <Header />
                <Toolbar />
                <Outlet />
                <Auth />
            </ContextProvider>
        );
    }

    return <Auth />;
};

export default PrivateRoute;
